
import cartType from "../../actions/cart/cartType";

const initialState = {

companySelected:[],


}

const companyReducer=( state = initialState, action) => {


switch(action.type) {



case cartType.SET_COMPANY_DETAILS:
    return{
        ...state,
companySelected:action.payload
    }



    default: return state;
}

}


export default companyReducer